class AppHolder {
    static setInstance(name, app) {
        AppHolder._apps[name] = app;
    }
    static getInstance(name) {
        const app = AppHolder._apps[name];
        if (!app) {
            throw Error(`[${name}] FronteggApp not found`);
        }
        return app;
    }
}
AppHolder._apps = {};

export { AppHolder };
